import React, { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { server } from "../../server";
import { useToast } from "../Layout/Toast/ToastProvider.jsx";

import "./AdminLogin.scss";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [visible, setVisible] = useState(false);
  const { showToast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();

    await axios
      .post(
        `${server}/shop/login-shop`,
        { email, password },
        { withCredentials: true }
      )
      .then((res) => {
        showToast("Авторизація пройшла успішно!", "success");
        navigate("/dashboard");
        window.location.reload(true);
      })
      .catch((err) => {
        showToast(err.response.data.message, "error");
      });
  };

  return (
    <div className="admin-login">
      <div className="admin-login__form-container">
        <div className="admin-login__form">
        <h2 className="admin-login__title">Admin Panelka</h2>
          <form onSubmit={handleSubmit}>
            <div className="admin-login__form-group">
              <label className="admin-login__form-label" htmlFor="email">
                Електронна пошта
              </label>
              <input
                className="admin-login__form-input"
                type="email"
                name="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="admin-login__form-group">
              <label className="admin-login__form-label" htmlFor="password">
                Пароль
                </label>
              <div className="admin-login__form-password-wrapper">
                <input
                  className="admin-login__form-input"
                  type={visible ? "text" : "password"}
                  name="password"
                  autoComplete="current-password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                {visible ? (
                  <AiOutlineEye
                    className="admin-login__form-icon"
                    size={25}
                    onClick={() => setVisible(false)}
                  />
                ) : (
                  <AiOutlineEyeInvisible
                    className="admin-login__form-icon"
                    size={25}
                    onClick={() => setVisible(true)}
                  />
                )}
              </div>
            </div>

            <div className="admin-login__form-checkbox-row">
              <label className="admin-login__form-checkbox-label">
                <input type="checkbox" name="remember-me" id="remember-me" />
                <span>Запям'ятати мене</span>
              </label>
            </div>

            <button
              type="submit"
              className="admin-login__form-submit-btn"
            >
              Увійти
            </button>
            <div className="admin-login__form-bottom-text">
              <h4>Якщо у вас виникли проблеми з входом зв'яжіться з командою розробників</h4>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
